import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllSurvey = async (params: any) => {
  const url = endpoints.SURVEY;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getSurveyById = async (id: number) => {
  const url = endpoints.SURVEY + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const updateSurvey = async (params: any) => {
  const url = endpoints.SURVEY + "/" + params.id;

  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const surveyService = {
  getAllSurvey,
  updateSurvey,
  getSurveyById,
};

export default surveyService;
